import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';

import * as styles from './BetPositionMobileTooltip.css';

interface IProps {
  children: React.ReactNode;
}

export const BetPositionMobileTooltip = ({ children }: IProps) => (
  <div className={styles['wrapper']}>
    <UIText2 color="current_color">{children}</UIText2>
  </div>
);
